import type { CountInWindowWindowOption } from './count-in-window-input'

/**
 * Names a set of day-valued windows the way every count surface names them.
 *
 * The token is the engine's — `30d` is thirty days back — and the wording is what
 * the reader has always seen beside it, so a surface states only which windows it
 * offers and never how they are spelled. Anything other than a whole number of
 * days is not a window these conditions have; the caller would be inventing one.
 */
export function dayWindows(...days: number[]): CountInWindowWindowOption[] {
    return days.map((count) => ({
        label: count === 1 ? '1 Day' : `${count} Days`,
        value: `${count}d`,
    }))
}
